export default "__VITE_ASSET__lTMUkgAd__"